import { Navigate, createFileRoute } from '@tanstack/react-router'

function ImportEmployeesRedirect() {
  return <Navigate to="/org/import-people" replace />
}

export const Route = createFileRoute('/org/import-employees')({
  component: ImportEmployeesRedirect,
})
